import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    window.open(cat.url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Browse Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-6">
          Select a category below to explore products on our main store
        </p>

        <div ref={dropdownRef} className="relative w-full max-w-lg mx-auto">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 rounded-xl bg-background-50 border border-background-300/60 text-foreground-800 text-sm md:text-base hover:border-primary-300 transition-all cursor-pointer"
          >
            <span className={selected ? "text-foreground-900" : "text-foreground-400"}>
              {selected || "Choose a category to explore..."}
            </span>
            <i
              className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${
                isOpen ? "rotate-180" : ""
              }`}
            ></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/80 rounded-xl z-40 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 transition-colors text-left cursor-pointer first:rounded-t-xl last:rounded-b-xl"
                >
                  <i className={`${cat.icon} text-primary-500 text-base w-5 h-5 flex items-center justify-center`}></i>
                  <span className="font-medium">{cat.name}</span>
                  <span className="ml-auto text-xs text-foreground-400">{cat.desc}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}